import { FaChalkboardTeacher, FaGraduationCap, FaUsers, FaLaptop } from "react-icons/fa";
import AboutCard from "./AboutCard";


const cardData = [
  {
    icon: <FaChalkboardTeacher />,
    title: "خبرة حقيقية",
    subtitle: "Expert Instructor",
    text:
      "أكتر من 10 سنين خبرة في تدريس اللغة الإنجليزية لطلاب المرحلة الثانوية، بأسلوب بسيط يخليك تفهم قبل ما تحفظ.",
  },

  {
    icon: <FaGraduationCap />,
    title: "منهج منظم",
    subtitle: "Smart Curriculum",
    text:
      "شرح مرتب خطوة بخطوة، مع التركيز على أهم أجزاء المنهج والأسئلة اللي بتساعدك تستعد للامتحان بشكل أفضل.",
  },

  {
    icon: <FaUsers />,
    title: "طلاب من كل مكان",
    subtitle: "Growing Community",
    text:
      "مجتمع تعليمي بيجمع طلاب من مختلف أنحاء مصر، وكل طالب عنده فرصة يتعلم ويتطور حسب مستواه.",
  },

  {
    icon: <FaLaptop />,
    title: "تعلم أونلاين",
    subtitle: "Learn Anywhere",
    text:
      "ذاكر من البيت وفي أي وقت يناسبك، مع فيديوهات وشرح وتدريبات تقدر ترجع لها وقت ما تحتاج.",
  },
];

function About() {
  return (
    <section id="about" className="about_section">

      {/* ================= HEADER ================= */}

      <div className="about_header">

        <span className="section_badge">
          ✦ ليه PureEng ؟
        </span>

        <h2>
          مش هدفنا إنك <span>تحفظ الإنجليزي</span>
          <br />
          هدفنا إنك <span>تفهمه وتعرف تستخدمه.</span>
        </h2>

        <p>
          مع مستر أحمد سعيد، هتلاقي شرح بسيط ومنظم،
          تدريبات مستمرة، ومتابعة تساعدك تطور مستواك
          وتدخل الامتحان وأنت واثق.
        </p>

      </div>


      {/* ================= CARDS ================= */}

      <div className="about_cards">

        {cardData.map((card, index) => (
          <AboutCard
            card={card}
            index={index}
            key={index}
          />
        ))}

      </div>


      {/* ================= TRUST BAR ================= */}

      <div className="about_trust">

        <div>
          <strong>10+</strong>
          <span>سنين خبرة</span>
        </div>

        <div>
          <strong>1000+</strong>
          <span>طالب</span>
        </div>

        <div>
          <strong>3</strong>
          <span>مراحل تعليمية</span>
        </div>

        <div>
          <strong>24/7</strong>
          <span>محتوى متاح</span>
        </div>

      </div>

    </section>
  );
}

export default About;
